<template>
  <div
    class="opple-config-navBar"
  >
    <div
      v-for="(item, index) in relationAction"
      :key="index"
      class="opple-config-navBar_item"
      :class="{active: currentTab === index}"
      @click="() => onItemClick(index)"
    >
      {{ item.Name }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'OppleConfigNavBar',
  props: {
    relationAction: {
      type: Array,
      default: () => []
    },
    currentTab: {
      type: Number,
      default: 0
    }
  },
 
  watch: {
    item(value) {
      this.setCom();
    }
  },

  mounted() {

  },

  methods: {
    onItemClick(tab) {
      // this.currentTab = tab;
      this.$emit('onActiveTab', tab)
    }
  },
};
</script>

<style lang="scss">
.opple-config-navBar {
  width: 283px;
  min-height: 228px;
  border-right: 2px solid #E0E5EC;

  &_item {
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    font-size: 14px;
    color: #111;
    text-indent: 80px;
    cursor: pointer;

    &.active {
      color: #0246AB;
      background: #E1EAF7;
    }
  }
}

</style>